import { useLazyQuery } from '@apollo/client';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from '@synoptic/ui-kit/dropdown-menu/dropdown-menu.js';
import { CreditCardIcon } from '@synoptic/ui-kit/icons/react/credit-card.js';
import { MoreHorizIcon } from '@synoptic/ui-kit/icons/react/more-horiz.js';
import { SettingsIcon } from '@synoptic/ui-kit/icons/react/settings.js';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { useRef, useState } from 'react';
import { gql } from '@/__generated__';
import { Link } from '@/routes-utils/navigation';
import { paths } from '@/routes-utils/paths';
import { actionsButton } from './streams-header.css';

const GetBillingPortalSession = gql(`
    query GetBillingPortalSession {
      getCustomerBillingPortalSession {
        url
      }
    }
  `);

export const StreamsHeaderActionsMenu = () => {
  const toast = useToast();
  const windowRef = useRef<Window | null>(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [getBillingPortalSession, { loading: billingPortalLoading }] =
    useLazyQuery(GetBillingPortalSession, {
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        const url = data.getCustomerBillingPortalSession?.url;
        if (url && windowRef.current) {
          windowRef.current.location.href = url;
        } else if (windowRef.current) {
          windowRef.current.close();
        }
        windowRef.current = null;
        setDropdownOpen(false);
      },
      onError: () => {
        if (windowRef.current) {
          windowRef.current.close();
          windowRef.current = null;
        }
        setDropdownOpen(false);
        toast.error({
          title: 'Failed to open billing portal',
          subTitle: 'Please try again',
        });
      },
    });

  return (
    <DropdownMenuRoot open={dropdownOpen} onOpenChange={setDropdownOpen}>
      <DropdownMenuTrigger>
        <IconButton
          className={actionsButton}
          variant="ghost"
          aria-label="Stream actions menu"
        >
          <MoreHorizIcon />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={'end'}>
        <DropdownMenuItem
          onSelect={(e) => {
            e.preventDefault();
            if (!billingPortalLoading) {
              // Open window immediately to fix PWA mobile limitation
              windowRef.current = window.open('about:blank', '_blank');
              getBillingPortalSession();
            }
          }}
          loading={billingPortalLoading}
          icon={<CreditCardIcon />}
        >
          Open billing portal
        </DropdownMenuItem>
        <DropdownMenuItem icon={<SettingsIcon />} asChild>
          <Link to={paths.settingsApiKeys}>See API settings</Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenuRoot>
  );
};
